import { makeStyles } from '@mui/styles'

// css style
export const useStyles = makeStyles({
  helpContainer: {
    marginTop: '20px',
    marginBottom: '60px',
  },
  listItem: {
    borderBottom: '1px solid #E0E0E0',
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemTextTitle: {
    marginBottom: '0px',
    fontSize: '20px!important',
    fontWeight: '500!important',
    textDecoration: 'underline',
  },
  listItemText: {
    margin: '0px',
    fontSize: '14px',
  },
  listItemIcon: {
    width: '24px',
    height: '24px',
    minWidth: 'inherit!important',
  },
  divider: {
    borderLeft: '1px solid #E0E0E0',
  },
  videoItem: {
    padding: '20px',
  },
  videoItemTitle: {
    margin: '5px 0px',
  },
  videoItemDescription: {
    margin: '0px',
    fontSize: '14px',
  },
  videoItemLink: {
    marginTop: '10px',
    textDecoration: 'underline',
    fontSize: '14px',
    color: '#000000',
  },
  faqContainer: {
    marginBottom: '100px',
    marginTop: '100px',
  },
  accordionContainer: {
    paddingTop: '6px',
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiAccordion-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiAccordion-root.Mui-expanded': {
      marginTop: '0px',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      marginTop: '0px',
      minHeight: '0px',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      marginTop: '12px',
    },
    '& .MuiAccordion-region': {
      padding: '0px 20px',
    },
  },
  needHelpContainer: {
    backgroundColor: '#F3F4F3',
    borderRadius: '16px',
    padding: '24px',
    height: '100%',
    '& a': {
      marginTop: '12px',
      display: 'flex',
    },
  },
  needHelpTitle: {
    fontSize: '32px',
    fontWeight: '600',
    lineHeight: '45px',
    letterSpacing: '0.15px',
    margin: '0px',
  },
  needHelpButtonIcon: {
    width: '18px',
    height: '18px',
    marginRight: '8px',
  },
  needHelpButton: {
    border: '1px solid #000000',
    borderRadius: '20px',
    textDecoration: 'none',
    justifySelf: 'flex-end',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    textTransform: 'capitalize',
  },
  resourceCards: {
    marginBottom: '100px',
    '& > .MuiGrid-item': {
      borderRight: '1px solid rgba(0, 0, 0, 0.12)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    '& > .MuiGrid-item:nth-child(3n)': {
      borderRight: 'none',
    },
    '& > .MuiGrid-item:nth-last-child(-n+3)': {
      borderBottom: 'none',
    }
  },
  resourceCard: {
    height: '100%',
    padding: '5px',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: '0px',
    '&:hover': {
      backgroundColor: 'rgba(37, 61, 130, 0.04)',
      '& .MuiButtonBase-root > img': {
        transform: 'translate(10px, -10px)',
        backgroundColor: 'transparent',
      }
    },
  },
  resourceCardImage: {
    transition: 'all 0.3s ease',
  },
  trainingMaterialSection: {
    marginBottom: '100px',
    padding: '40px',
    backgroundColor: '#F3F4F3',
  },
  supportPageNav: {
    minWidth: '180px',
    padding: '16px',
    borderLeft: '1px solid #E0E0E0',
    marginLeft: '24px',
  },
  trainingMaterialCard: {
    margin: '20px',
    borderLeft: '1px solid #E0E0E0',
    paddingLeft: '60px',
    padding: '20px',
    '&:hover': {
      backgroundColor: 'rgba(37, 61, 130, 0.04)',
      '& .MuiButtonBase-root > img': {
        transform: 'translate(10px, -10px)',
        backgroundColor: 'transparent',
      }
    }
  }
})
